import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconNightVisionAuto = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={25}
      fill="none"
      viewBox="0 0 24 25"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <g clipPath="url(#clip0_4873_3791)">
        <path
          d="M17.4809 17.3219C15.8055 17.3215 14.1534 16.9308 12.6573 16.1809C11.1612 15.4311 9.86264 14.3432 8.86588 13.0043C7.86912 11.6654 7.20187 10.1129 6.91766 8.47138C6.63345 6.82982 6.7402 5.14489 7.22934 3.55176C5.60574 4.29576 4.19522 5.43182 3.12627 6.85645C2.05732 8.28107 1.36392 9.94897 1.10926 11.7082C0.854602 13.4674 1.04677 15.262 1.66826 16.9285C2.28974 18.595 3.32079 20.0804 4.66747 21.2493C6.01414 22.4183 7.63363 23.2337 9.37838 23.6212C11.1231 24.0087 12.9377 23.956 14.6567 23.4679C16.3758 22.9799 17.9446 22.0719 19.2204 20.8268C20.4962 19.5817 21.4383 18.1138 21.9609 16.4141C20.5571 17.0612 19.0283 17.3218 17.4809 17.3219Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.34716 10.8657L11.1292 6.63572H12.2512L14.0392 10.8657H12.7912L12.4912 10.1097H10.8652L10.5652 10.8657H9.34716ZM11.2072 9.20372H12.1492L11.6812 8.01572L11.2072 9.20372ZM15.2105 10.9377C14.5205 10.9377 14.1005 10.4757 14.1005 9.73772V7.61972H15.2405V9.37772C15.2405 9.73172 15.4265 9.92372 15.7025 9.92372C15.9785 9.92372 16.1825 9.73172 16.1825 9.37772V7.61972H17.3165V10.8657H16.1825V10.4157C15.9725 10.6857 15.6725 10.9377 15.2105 10.9377ZM19.0372 10.9317C18.3532 10.9317 17.9512 10.6317 17.9512 9.85772V8.53172H17.5672V7.61972H17.9512V6.79772H19.0852V7.61972H19.8412V8.53172H19.0852V9.63572C19.0852 9.86372 19.1872 9.95972 19.3972 9.95972C19.5472 9.95972 19.6913 9.91772 19.8293 9.85172V10.7397C19.6252 10.8537 19.3552 10.9317 19.0372 10.9317ZM21.7193 10.9437C20.6873 10.9437 19.9373 10.1817 19.9373 9.25772V9.24572C19.9373 8.32172 20.6933 7.54772 21.7313 7.54772C22.7693 7.54772 23.5193 8.30972 23.5193 9.23372V9.24572C23.5193 10.1697 22.7633 10.9437 21.7193 10.9437ZM21.7313 9.97772C22.1453 9.97772 22.4153 9.64772 22.4153 9.25772V9.24572C22.4153 8.84372 22.1213 8.50772 21.7193 8.50772C21.3053 8.50772 21.0413 8.83772 21.0413 9.23372V9.24572C21.0413 9.64172 21.3293 9.97772 21.7313 9.97772Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};
